import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import Swiper from "swiper";
import { Data } from "../utils/data";
import { classNames, selectors, DATA_KEY } from "./ef-carousel.constants";
export var EfCarousel = /*#__PURE__*/function () {
  function EfCarousel(el, config) {
    _classCallCheck(this, EfCarousel);

    this._carouselEl = this.constructor._getSwiperEl(el);
    this._config = this.constructor._getConfig(el, config);

    this._init();

    Data.setData(el, DATA_KEY, this);
  }

  _createClass(EfCarousel, [{
    key: "_init",
    value: function _init() {
      return new Swiper(this._carouselEl, this._config);
    }
  }], [{
    key: "_getSwiperEl",
    value: function _getSwiperEl(el) {
      var _el = el.querySelector(selectors.SWIPER);

      if (!_el) {
        throw new Error("EfCarousel: incorrect markup, should contain ".concat(selectors.SWIPER));
      }

      return _el;
    }
  }, {
    key: "_getConfig",
    value: function _getConfig(el, config) {
      var smallCardsSlider = el.classList.contains(classNames.SMALL);
      return _objectSpread({
        spaceBetween: smallCardsSlider ? 25 : 30,
        slidesPerView: smallCardsSlider ? 3 : 1,
        slidesPerGroup: smallCardsSlider ? 3 : 1,
        centeredSlides: !smallCardsSlider,
        // If we need pagination
        pagination: {
          el: el.querySelector(selectors.PAGINATION),
          clickable: true
        },
        slideToClickedSlide: true,
        // Navigation arrows
        navigation: {
          prevEl: el.querySelector(selectors.PREVBUTTON),
          nextEl: el.querySelector(selectors.NEXTBUTTON)
        },
        keyboard: {
          enabled: true
        },
        breakpoints: {
          768: {
            spaceBetween: 8,
            slidesPerView: 1,
            slidesPerGroup: 1
          },
          1024: {
            slidesPerView: smallCardsSlider ? 2 : 1,
            slidesPerGroup: smallCardsSlider ? 2 : 1
          }
        }
      }, config);
    }
  }, {
    key: "activate",
    value: function activate(el) {
      var data = Data.getData(el, DATA_KEY);

      if (!data) {
        data = new EfCarousel(el);
      }

      return data;
    }
  }]);

  return EfCarousel;
}();